import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {taskTemplatesContainerId} from 'yougile-model'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {LinkButtonWrapped} from '@components/movement-templates/link-button-wrapped'
import {useSyncEvent} from '@containers/hooks'
import {HelpImage} from './help-image'
import {TaskTemplateRow} from './task-template-row'
import {useTaskTemplatesStore} from './task-templates-store'

const TwContainer = tw.div`
  flex-1
  flex
  flex-col
  min-h-0
`

const TwRows = tw.div`
  flex
  flex-col
`

const TwTitle = tw.div`
  text-primary
  text-sm-semibold
  cursor-default
`

const TwHeader = tw.div`
  flex
  items-center
  h-32
`

const TwContentContainer = tw.div`
  flex
  items-center
  gap-16
  ml-auto
`

export const TaskTemplatesMain = observer(() => {
  const [state, store] = useTaskTemplatesStore()
  const {rows} = state

  useEffect(() => {
    store.syncRows()
  }, [])

  const opt = {filter: taskTemplatesContainerId}
  useSyncEvent('current', opt, store.syncRows, [store.boardId])

  if (!rows) {
    return null
  }

  const showHelp = !rows.length

  return (
    <TwContainer>
      <TwHeader>
        <TwTitle>{Lang.msg.taskTemplates.title}</TwTitle>
        <TwContentContainer>
          <LinkButtonWrapped
            icon={'IconPlus'}
            onMouseDown={store.goToCreate}
            text={Lang.msg.taskTemplates.createTemplate}
          />
          <LinkButtonWrapped
            icon={'IconCustomExistingPlus'}
            onMouseDown={store.goToExistence}
            text={Lang.msg.taskTemplates.createFromExistTask}
          />
        </TwContentContainer>
      </TwHeader>

      <WithPerfectScrollbar className="min-h-0 flex-1 flex flex-col pr-16 -mr-16">
        {!!rows.length && (
          <TwRows>
            {rows.map(row => (
              <TaskTemplateRow key={row.id} {...row} />
            ))}
          </TwRows>
        )}

        {showHelp && <HelpImage className={'mt-8'} />}
      </WithPerfectScrollbar>
    </TwContainer>
  )
})
